import React, { useEffect, useState } from 'react';
import { ArticleService } from '../../../../services/ArticleService';
import { FamilyService } from '../../../../services/FamilyService';
import { Spinner, Card, Tabs, Tab, Row, Col, Accordion, Button, OverlayTrigger, Alert, Tooltip, Dropdown, Badge, NavDropdown, Nav } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { isDark, granted } from '../../../../helper/Helper'
import ErrorManager from "../../../error-manager/ErrorManager";
import Fournisseurs from "./fournisseurs/Fournisseurs";
import Tags from "./tags/Tags";
import Tarifs from "./tarifs/Tarifs";
import Factures from "./factures/Factures";
import Proformas from "./proformas/Proformas";
import Historique from "./historique/Historique";
import Signaletique from "./signaletique/Signaletique";
import { GlobalContext } from "../../../../services/GlobalProvider";

const ArticleDetails = (props) => {

    const { grants } = React.useContext(GlobalContext);

    let [openElement, setOpenElement] = useState("signaletique")
    let [article, setArticle] = useState()
    const [getArticleLoading, setGetArticleLoading] = useState()
    const [tags, setTags] = useState([])

    useEffect(() => {
        setArticle()
        getArticle()
        setOpenElement("signaletique")
    }, [props.articleId]);

    function handleTabSelect(key) {
        setOpenElement(key)
    }

    function getArticle() {
        setGetArticleLoading(true)
        ArticleService.getArticle(props.folderId, props.articleId).then(res => {
            setArticle(res.status == 200 ? res.data.data : { warning: res.statusText })
            setGetArticleLoading(false)
            setTags(res?.data?.data?.tags)
        }).catch(error => {
            setGetArticleLoading(false)
            setArticle({ error: error })
        });
    }

    function tabChange() {
        getArticle()
        props.onTabChange()
    }

    return (
        <div id="ArticleDetails">

            {(!article && getArticleLoading) &&
                <span className="hloader mt-3"></span>
            }

            {article?.warning &&
                <div className="d-inline-block w-100 mt-4">
                    <Alert variant="warning">
                        {article?.warning}
                    </Alert>
                </div>
            }

            {article?.error &&
                <div className="d-inline-block w-100 mt-4">
                    <ErrorManager error={article?.error} />
                </div>
            }

            {
                (article && !article.warning && !article.error) && (
                    <>
                        <div className="d-flex mb-4">
                            <div className="me-auto">
                                <h6 className="m-0">{article.designation}<span className="text-gray-500 ms-2">{article.code}</span></h6>
                                <div className="me-3">
                                    <Badge bg="light" text="dark" className="me-2">Famille : {article?.famille?.designation}</Badge>
                                    <Badge bg="light" text="dark" className="me-2">HT : {article.prix_vente_ht}</Badge>
                                    <Badge bg="light" text="dark" className="me-2">TTC : {article.prix_vente_ttc}</Badge>
                                </div>
                                {tags?.length > 0 &&
                                    <span className="bubble-tags-container border mt-1">
                                        Tags :
                                        {tags.map(tag => (
                                            <span key={tag._id} className="bubble" style={{ backgroundColor: tag.couleur }}>
                                                <span style={{ backgroundColor: tag.couleur }} className={"label " + (isDark(tag.couleur) ? "text-dark" : "text-white")}>{tag.tag}</span>
                                            </span>
                                        ))}
                                    </span>
                                }

                            </div>

                            {props.elementActions.length > 0 &&
                                <Dropdown className="float-end ms-2 me-3">
                                    <OverlayTrigger
                                        placement="left"
                                        delay={{ show: 800 }}
                                        overlay={
                                            <Tooltip>
                                                Plus d'actions
                                            </Tooltip>
                                        }
                                    >
                                        <Dropdown.Toggle variant="secondary" className='no-btn-caret'>
                                            <i className="material-icons i-lg">more_horiz</i>
                                        </Dropdown.Toggle>
                                    </OverlayTrigger>
                                    <Dropdown.Menu>
                                        {props.elementActions.map((element) => (
                                            <Dropdown.Item key={element.title} onClick={() => props.setElementAction(element.action, article)}>{element.title}</Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            }
                        </div>


                        <div>

                            <Nav className="mb-3" variant="pills" defaultActiveKey={openElement} onSelect={handleTabSelect}>
                                <Nav.Item><Nav.Link eventKey="signaletique">Signalétique</Nav.Link></Nav.Item>
                                <Nav.Item><Nav.Link eventKey="tags">Tags</Nav.Link></Nav.Item>
                                {granted(grants, "fournisseurs.consult") &&
                                    <Nav.Item><Nav.Link eventKey="fournisseurs">Fournisseurs</Nav.Link></Nav.Item>
                                }
                                <Nav.Item><Nav.Link eventKey="tarifs">Tarifs</Nav.Link></Nav.Item>
                                {(granted(grants, "factures.consult") || granted(grants, "proformas.consult")) &&
                                    <NavDropdown
                                        title={
                                            openElement == "factures" ? "Factures" :
                                                openElement == "proformas" ? "Proformas" :
                                                    "Facturation"
                                        }
                                        id="nav-dropdown"
                                        active={openElement == "factures" || openElement == "proformas"}
                                    >
                                        {granted(grants, "factures.consult") && <NavDropdown.Item eventKey="factures">Factures</NavDropdown.Item>}
                                        {granted(grants, "proformas.consult") && <NavDropdown.Item eventKey="proformas">Proformas</NavDropdown.Item>}
                                    </NavDropdown>
                                }
                                <Nav.Item><Nav.Link eventKey="historique">Historique</Nav.Link></Nav.Item>
                            </Nav>

                            <div className="light-v-scroll height-full-min-250 pe-2 tab-pane">
                                <Row>
                                    <Col>
                                        {openElement == "signaletique" &&
                                            <Signaletique folderId={props.folderId} article={article} />
                                        }
                                        {openElement == "tags" &&
                                            <Tags folderId={props.folderId} article={article} setTags={(tags) => setTags(tags)} isArticleLoading={getArticleLoading} onTagChange={() => tabChange()} />
                                        }
                                        {openElement == "fournisseurs" &&
                                            <Fournisseurs folderId={props.folderId} article={article} onFournisseurChange={() => tabChange()} />
                                        }
                                        {openElement == "tarifs" &&
                                            <Tarifs folderId={props.folderId} article={article} onTarifChange={() => tabChange()} />
                                        }
                                        {openElement == "factures" &&
                                            <Factures folderId={props.folderId} article={article} />
                                        }
                                        {openElement == "proformas" &&
                                            <Proformas folderId={props.folderId} article={article} />
                                        }
                                        {openElement == "historique" &&
                                            <Historique folderId={props.folderId} article={article} />
                                        }
                                    </Col>
                                </Row>
                            </div>

                        </div>

                    </>
                )
            }
        </div>

    )

}

export default ArticleDetails;